<template>
    <a-modal title="开票资料"
             :width="600"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="loading">
        <a-form  :form="form" class="mt-1">
        <table style="width:100%;height: 300px;" >
            <tr>
                <th>姓名：</th>
                <td colspan="3">
                    <a-form-item >
                        <a-input
                                disabled
                                style="color: black;width: 250px; "
                                v-decorator="['supplierName',{initialValue:bill.supplierName}]"
                        />
                    </a-form-item>
                </td>
            </tr>

            <tr>
                <th>开户银行：</th>
                <td>
                    <a-form-item >
                        <a-input
                                v-decorator="['bankName',{initialValue:bill.bankName,rules:[{ required: true, message: '开户银行不能为空'}]}]"
                        />
                    </a-form-item>
                </td>
            </tr>

            <tr>
                <th> 银行帐号：</th>
                <td>
                    <a-form-item >
                        <a-input
                                v-decorator="['bankAccount',{initialValue:bill.bankAccount,rules: [{ required: true, message: '银行帐号不能为空'}]}]"
                        />
                    </a-form-item>
                </td>
            </tr>

            <tr>
                <th>账户名称：</th>
                <td>
                    <a-form-item >
                        <a-input
                                style="color: black;"
                                disabled
                                v-decorator="['bankAccountName',{initialValue:bill.bankAccountName,rules: [{required:true,message:'账户名称不能为空'}]}]"
                        />
                    </a-form-item>
                </td>
            </tr>

            <tr>
                <th>银行联行号:</th>
                <td>
                    <a-form-item >
                        <a-input
                                v-decorator="['bankCode',{initialValue:bill.bankCode,rules:[{ required: true, message: '银行联行号不能为空'},{type:'string',pattern: /^[0-9]{12}$/,message:'银行联行号格式不正确'}]}]"
                        />
                    </a-form-item>
                </td>
            </tr>

            <tr>
                <th style="width: 200px;">  <span style="color: red">银行联行号查询可参考</span></th>
                <td style="vertical-align: middle;">
                    <a href="javascript:;" @click="onThirdSite('http://www.kaihuhang.cn/')" > http://www.kaihuhang.cn/</a>
                    <span>&nbsp;&nbsp; 或 &nbsp;&nbsp;</span>
                    <a href="javascript:;" @click="onThirdSite('http://www.lianhanghao.com/')"> http://www.lianhanghao.com/</a>
                </td>
            </tr>

        </table>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                modalLoading: false,
                loading: false,
                bill: '',
            }
        },
        methods: {
            initInfo() {
                let that = this
                this.$http.get('/api/v1/supplier/billInfo/get.json').then(function (res) {
                    that.bill = res.result
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    if (this.bill.id) {
                        params.id = this.bill.id
                    }
                    if (this.bill.supplierType) {
                        params.supplierType = this.bill.supplierType
                    }
                    if (this.bill.supplierId) {
                        params.supplierId = this.bill.supplierId
                    }
                    let that = this
                    that.loading = true
                    this.$http.post('/api/v1/supplier/billInfo/edit.json',qs.stringify(params)).then(function (response) {
                        that.loading = false
                        if (response.code === 200) {
                            that.$message.success('更新成功')
                            that.$emit('cancel')
                        }
                    })
                });
            },
            onThirdSite(value){
                window.open(value)
            }
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 250px;
    }

    /*.fx-form th {*/
    /*    width: 130px;*/
    /*}*/
    /*table {*/
    /*    height: 400px;*/
    /*}*/
    th{
        width: 175px;
    }
    td{
        vertical-align: bottom;
    }
</style>
